<template>
    <admin-layout 
    title="View Block Date"
    show-back
    :backUrl="`/branches/edit/${branchId}`">
        <BranchesLayout :branch-id="branchId">
            <template #contents>
                <div class="p-8">
                    <FormSection>
                        <template #title>
                            Booking Time Slot Duration Information
                        </template>

                        <template #description>
                            Relevant data and other details
                        </template>

                        <template #form>
                            <!-- <div class="col-span-full">
                                <pre>{{ form }}</pre>
                            </div> -->
                            <div class="col-span-6">

                                <MultiselectInput
                                    label="Booking Time Slot Duration"
                                    placeholder="Duration"
                                    id="time_duration"
                                    name="time_duration"
                                    v-model="form.time_slot"
                                    :options="options"
                                    searchable
                                    @click="$emit('clearProvince')"
                                    :error="errors.time_slot ? errors.time_slot[0] : ''"
                                />
                                
                            </div>
                        </template>
                        <template #actions>
                            <ButtonComponent v-if="$hasPermission('set-booking-time-intervals')" @click="submit">
                                Save Changes
                            </ButtonComponent>
                        </template>
                    </FormSection>
                </div>

                
           

            </template>
        </BranchesLayout>

        <SuccessModal
            :show="showSuccess"
            @cancel="showSuccess = false"
            @confirm="showSuccess = false"
            action-text="Close"
            title="Branch"
            content="Branch Updated Successfully!"
        />

        <ErrorModal
            width="w-[548px]"
            title="Warning"
            action-text="Close"
            cancel-text="Go back"
            :show="showError"
            @close="showError = false"
            @confirm="showError = false"
            :errors="errors"
        >
            <template #content>
                {{ errorMsg }}
            </template>
        </ErrorModal>

        <PageLoader v-if="loader" />


    </admin-layout>
</template>

<script setup lang="ts">
import AdminLayout from '@/layouts/AdminLayout.vue';
import BranchesLayout from '../components/BranchesLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import { useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import AuthService from '@/classes/AuthService';
import branch from "@/classes/Branch";
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

const route = useRoute();
/**
 * ********************************
 * Data 
 * ********************************
 */
const loader           = ref(false);
const branchId         = ref(route.params.id as unknown as string);
const showError   = ref(false);
const errorMsg    = ref(false);
const errors      = ref([]);
const show        = ref(false);
const showSuccess = ref(false);
const form = ref({
    time_slot         : '',
})

const fetchData = async () => {
    try {
        loader.value = true;
        const response = await branch.editBranch(branchId.value)
        loader.value = false;
        Object.assign(form.value, response.data.branch)
    }
    catch(err: any) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response.data.message;

        if(err.response.status == 422) {
            errors.value = err.response.data.errors;
        }
    }
}

const submit = async () => {
    loader.value = true;
    const data = branch.formatData(form.value, branchId.value)

    try {
        await branch.updateTimeSlot(branchId.value, data)
        loader.value      = false;
        show.value        = false;
        showSuccess.value = true
                
        setTimeout(() => {
            window.location.replace('/branches')
        }, 2000);
    }
    catch(error: any) {
        show.value      = false;
        showError.value = true;
        errorMsg.value  = error.response.data.message;

        if(error.response.status == 422) {
            errors.value = error.response.data.errors;
        }
        errorResponse(error)
    }
}

const errorResponse = (err: any) => {
    loader.value = false

    if(err?.response.status == 401) {
        AuthService.redirectToLogin()
    }
}

const options = [
    { id: 15, label: '15 Minutes', value: 15 },
    { id: 30, label: '30 Minutes', value: 30 },
]


onMounted(() => {
    fetchData()    
})
</script>